var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoveAsset(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 19,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.808 17.346a.654.654 0 0 1-.654.654h-17a.654.654 0 0 1-.654-.654V1.654c0-.361.293-.654.654-.654h17c.361 0 .654.293.654.654v15.692ZM22.5 6.931v-.7H6.808v10.461H22.5V6.931Zm0-4.623H6.808v2.615H22.5V2.308ZM8.442 4.269a.654.654 0 1 1-.051-1.307.654.654 0 0 1 .051 1.307Zm2.289 0a.654.654 0 1 1-.051-1.307.654.654 0 0 1 .051 1.307Zm2.288 0a.654.654 0 1 1-.051-1.307.654.654 0 0 1 .051 1.307Z",
    fill: "#264D6D",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.5 5.65)",
    stroke: "#264D6D"
  }, /*#__PURE__*/React.createElement("circle", {
    strokeWidth: 1.3,
    fill: "#FFF",
    fillRule: "nonzero",
    cx: 4.35,
    cy: 4.35,
    r: 4.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.35 4.35h4m-2 2 2-2m-2-2 2 2",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoveAsset);
export default __webpack_public_path__ + "static/media/moveAsset.aa214836ff236cb218bd9d7d90b98a99.svg";
export { ForwardRef as ReactComponent };